import type { VoidComponent } from "solid-js";
import type { Id } from "@thisbeyond/solid-dnd";
import { createDroppable } from "@thisbeyond/solid-dnd";
import DropZone from "../../../components/field/dropZone/DropZone";

const LastDropZone: VoidComponent<{ ignoredItems: Id[] }> = (props) => {
  const droppable = createDroppable("last");

  return (
    <div class="relative">
      <div class="absolute top-1 w-full" use:droppable>
        <DropZone active={droppable.isActiveDroppable && !props.ignoredItems.includes("last")} />
      </div>
    </div>
  );
};

export default LastDropZone;
